import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={18}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.366 3.13a9.004 9.004 0 1 0 0 12.74 9.018 9.018 0 0 0 0-12.74ZM3.868 14.628a7.265 7.265 0 0 1-.573-9.6L13.467 15.2a7.265 7.265 0 0 1-9.6-.572Zm10.84-.658L4.525 3.798A7.253 7.253 0 0 1 14.697 13.97h.011Z"
      fill="#00000099"
    />
  </svg>
)

export default SvgComponent